"use strict";

class PopupAnimation{
  constructor() {
    if( document.querySelector( '.ordered-pop-up' ) ) {
      this.container = Array.prototype.slice.call( document.querySelector( '.ordered-pop-up' ).children ) ;
    }
    this.raf;
    this.events();
  }

  events() {
    if( this.container ) {
      window.addEventListener( 'scroll', this.rafScroll.bind(this) );
      window.addEventListener( 'load', this.popup.bind(this) );
    }
  }

  // methods
  rafScroll() {
    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
    }
      this.raf = window.requestAnimationFrame(this.popup.bind(this));
  }

  popup( e ) {
    var increaseTime = 100;
  
    this.container.forEach( node => {
        var top = node.parentElement.getBoundingClientRect().top;
  
        setTimeout( () => {
  
          if( top <= 450 ) {
            node.classList.add( 'slide-vertical' ); 
            node.style.opacity = 1;
          }
  
        }, increaseTime );
  
        increaseTime = increaseTime + 200;
    });
  }
}

export default PopupAnimation;